export default __webpack_public_path__ + "static/media/sanghongfei.c154deb5.jpg";